export const FORM_NAMES = {
    FORM1095B: "Form1095B",  
}

export const FORM_FIELD_NAMES = {
    PAYER_ID: "PayerID",  
    PAYEE_ID: "PayeeID",  
    ISSUER_ID: "IssuerID",  
}